import { render, staticRenderFns } from "./FilmItem.vue?vue&type=template&id=9bcaf6c4&"
import script from "./FilmItem.vue?vue&type=script&lang=js&"
export * from "./FilmItem.vue?vue&type=script&lang=js&"
import style0 from "./FilmItem.vue?vue&type=style&index=0&id=9bcaf6c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports